<template>
  <section class="relative bg-surface-1 px-6 lg:px-16 xl:px-40 py-16 md:py-24">
    <div class="flex items-start justify-between gap-6 mb-12 md:mb-16">
      <div class="flex items-start gap-2">
        <div class="bg-primary-dark rounded-[2px] w-3 h-3 mt-[13px] shrink-0" />
        <h2 class="font-display font-semibold text-3xl md:text-[56px] leading-tight text-white !mt-0 !mb-0">
          {{ t('home.blog.title') }}
        </h2>
      </div>
      <RouterLink
        :to="{ name: 'blog' }"
        class="hidden md:inline-flex items-center rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[15px] px-4 py-2 transition-colors mt-[18px] shrink-0"
      >
        {{ t('home.blog.cta') }}
      </RouterLink>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-4 gap-6">
      <RouterLink
        :to="{ name: 'blogDetail', params: { slug: featured.key } }"
        class="lg:col-span-2 group bg-white hover:bg-white text-surface-1 hover:text-surface-1 rounded overflow-hidden flex flex-col lg:aspect-[788/525] p-4"
      >
        <div class="flex flex-col gap-4">
          <h3 class="font-display font-semibold text-2xl md:text-[32px] leading-tight text-[#141414] !mt-0 !mb-0 group-hover:text-primary-dark transition-colors">
            {{ t(`blog.articles.${featured.key}.name`) }}
          </h3>
          <p class="font-sans text-base text-[#111] !mt-0 !mb-0">
            {{ t(`blog.articles.${featured.key}.body`) }}
          </p>
        </div>
        <div class="relative flex-1 mt-4 min-h-[200px] rounded overflow-hidden">
          <img :src="articleImage(featured.key)" alt="" aria-hidden="true" class="absolute inset-0 w-full h-full object-cover" />
          <div class="absolute inset-0 bg-black/30 pointer-events-none" />
          <span class="absolute top-4 left-4 inline-flex items-center px-3 py-1 rounded bg-white/10 backdrop-blur-sm text-white text-xs uppercase tracking-wide">
            {{ t(`blog.categories.${featured.category}`) }}
          </span>
          <span class="absolute top-4 right-4 inline-flex items-center px-3 py-1 rounded bg-white/10 backdrop-blur-sm text-white text-xs uppercase tracking-wide">
            {{ t(`blog.articles.${featured.key}.tag`) }}
          </span>
        </div>
      </RouterLink>

      <RouterLink
        v-for="article in smallArticles" :key="article.key"
        :to="{ name: 'blogDetail', params: { slug: article.key } }"
        class="group bg-white hover:bg-white text-surface-1 hover:text-surface-1 rounded overflow-hidden flex flex-col lg:aspect-[382/525] p-4"
      >
        <div class="flex flex-col gap-4">
          <h3 class="font-display font-semibold text-xl md:text-2xl leading-tight text-[#141414] !mt-0 !mb-0 group-hover:text-primary-dark transition-colors">
            {{ t(`blog.articles.${article.key}.name`) }}
          </h3>
          <p class="font-sans text-sm text-[#111] !mt-0 !mb-0">
            {{ t(`blog.articles.${article.key}.body`) }}
          </p>
        </div>
        <div class="relative flex-1 mt-4 min-h-[180px] rounded overflow-hidden">
          <img :src="articleImage(article.key)" alt="" aria-hidden="true" class="absolute inset-0 w-full h-full object-cover" />
          <div class="absolute inset-0 bg-black/30 pointer-events-none" />
          <span class="absolute top-4 left-4 inline-flex items-center px-3 py-1 rounded bg-white/10 backdrop-blur-sm text-white text-xs uppercase tracking-wide">
            {{ t(`blog.categories.${article.category}`) }}
          </span>
          <span class="absolute bottom-4 left-4 inline-flex items-center px-3 py-1 rounded bg-white/10 backdrop-blur-sm text-white text-xs uppercase tracking-wide">
            {{ t(`blog.articles.${article.key}.tag`) }}
          </span>
        </div>
      </RouterLink>
    </div>

    <RouterLink
      :to="{ name: 'blog' }"
      class="md:hidden mt-8 inline-flex items-center rounded bg-primary hover:bg-primary-dark text-white hover:text-white text-[15px] px-4 py-2 transition-colors"
    >
      {{ t('home.blog.cta') }}
    </RouterLink>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { articleImage, articles } from '@/views/blog/articles'

const { t } = useI18n()

// The three newest articles.
const [featured, ...smallArticles] = articles.slice(0, 3)
</script>
